// Romero Watches — Logo oficial.
// Imagen del monograma RW + corona dorada sobre fondo azul marino.
// Servida desde /public/romero-logo.jpg.
export const Logo = ({ className = "", size = "md", withWordmark = true }) => {
  const sizes = {
    sm: { img: "h-9 w-9", mark: "text-sm", word: "text-[9px]" },
    md: { img: "h-12 w-12", mark: "text-xl", word: "text-[10px]" },
    lg: { img: "h-20 w-20", mark: "text-3xl", word: "text-xs" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className={`flex items-center gap-3 group ${className}`}
      aria-label="Romero Watches"
    >
      <span
        className={`${s.img} relative inline-flex items-center justify-center overflow-hidden rounded-full ring-1 ring-[var(--brand-gold)]/40 shadow-[0_4px_18px_-6px_rgba(226,195,127,0.35)] shrink-0`}
      >
        <img
          src="/romero-logo.jpg"
          alt="Romero Watches monograma"
          className="absolute inset-0 w-full h-full object-cover scale-[1.15]"
        />
      </span>

      {withWordmark && (
        <span className="hidden sm:flex flex-col leading-none">
          <span
            className={`font-serif-rw ${s.mark} tracking-[0.08em] text-slate-50`}
          >
            Romero
          </span>
          <span
            className={`font-accent-rw ${s.word} uppercase tracking-[0.32em] text-[var(--brand-gold)] mt-1.5`}
          >
            Watches
          </span>
        </span>
      )}
    </a>
  );
};

export default Logo;
